var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgif"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url,"id":"mobsf","scrolling":"no","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }